import { render, staticRenderFns } from "./SuperDocQuestionMessage.vue?vue&type=template&id=459e9692&scoped=true"
import script from "./SuperDocQuestionMessage.vue?vue&type=script&lang=js"
export * from "./SuperDocQuestionMessage.vue?vue&type=script&lang=js"
import style0 from "./SuperDocQuestionMessage.vue?vue&type=style&index=0&id=459e9692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459e9692",
  null
  
)

export default component.exports